













import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import { DataPoint, HSL, Name, NameData } from "../models";
import GenderIcon from "../components/GenderIcon.vue";
import NameStreamGraph from "../components/NameStreamGraph.vue";
import VueSwing from "vue-swing/VueSwing.vue";
import { mdiClose } from "@mdi/js";

@Component({})
export default class CookieBanner extends Vue {
  mdiClose = mdiClose;

  acceptCookiePolicy() {
    this.$emit("acceptCookiePolicy");
  }
}
